<template>
    <div class="ownerChange">
        <bv-top></bv-top>
        <van-cell-group>
          <van-cell    value-class="van-cell_value"  v-if='bindNumber >0'>
            <van-notice-bar :scrollable="false" >
              <p class="van-color-text-assist">
                您有{{bindNumber}}个业主信息变更申请审核不通过。
                <span class="van-color-warning" @click="goChangeOwnerReview" style="font-weight: bold">点击查看</span>
              </p>
            </van-notice-bar>
          </van-cell>
            <van-field
                    v-model.trim="regionName"
                    clearable
                    label="所属小区"
                    required
                    placeholder="请输入小区名称"
                    :rules="[{required: true, message: '请输入小区名称'}]"
            >
            </van-field>
            <!--小区名称下拉列表-->
            <van-cell-group id="regionSearch" class="regionList" v-if="searchShow">
                <van-cell
                        v-for="item in RegionList"
                        :key="item.regionNo"
                        :title="item.regionName"
                        @click="regionListClick(item)"
                        style=" float: right"
                />
            </van-cell-group>
            <!--选择房屋-->
            <van-field
                    readonly
                    required
                    clickable
                    label="选择房屋"
                    :value="houseValue"
                    placeholder="请选择房屋"
                    :rules="[{required: true, message: '请选择房屋'}]"
                    @click="houseInputClick"
            />
            <!--房屋选择器-->
            <van-popup id="searchHouse" v-model="showPicker" round position="bottom">
                <van-picker
                        show-toolbar
                        :columns="houseDate"
                        @cancel="showPicker = false"
                        @confirm="onConfirmHouse"
                        @change="housePickerChange"
                />
            </van-popup>
          <van-field
              v-model.trim="ownerName"
              required
              clearable
              label="业主姓名"
              placeholder="请输入姓名"
              :rules="[{required: true, message: '请输入姓名'}]"
          />
          <van-field
              v-model.trim="ownerCertNo"
              required
              clearable
              label="身份证号"
              placeholder="请输入身份证号"
              :rules="[{required: true, message: '请输入身份证号'}]"
          />
          <van-field
              v-model.trim="ownerName1"
              clearable
              label="共有人姓名"
              placeholder="若有多个业主请输入"
          />
          <van-field
              v-model.trim="ownerCertNo1"
              clearable
              label="共有人身份证号"
              placeholder="若有多个业主请输入"
          />
          <van-field
              v-model.trim="phoneNo"
              clearable
              label="联系人手机号"
              type = "tel"
              required
              placeholder="请输入手机号"
              :rules=" [{required: true, message: '请填写手机号码'}, {validator:validateMobile, message:'请输入正确的手机号'}]"
          />

        </van-cell-group>


        <van-cell   title="身份正面上传"  value-class="van-cell_value">
          <template >
            <van-uploader  v-model="fileShowList1" :before-read="beforeRead1" :after-read="afterRead1" accept=".jpg,.jpeg,.png"
                           :before-delete="delImg1" multiple :max-count="5">
            </van-uploader>
          </template>

        </van-cell>
        <van-cell   title="身份反面上传" value-class="van-cell_value">
          <template >
            <van-uploader  v-model="fileShowList2" :before-read="beforeRead1" :after-read="afterRead2"  accept=".jpg,.jpeg,.png"
                           :before-delete="delImg2" multiple :max-count="5">
            </van-uploader>
          </template>
        </van-cell>
        <van-cell   title="购买合同或房本" value-class="van-cell_value">
          <template >
            <van-uploader  v-model="fileShowList3" :before-read="beforeRead1" :after-read="afterRead3" accept=".jpg,.jpeg,.png"
                           :before-delete="delImg3" multiple :max-count="10">
            </van-uploader>
          </template>

        </van-cell>

        <van-row type="flex" justify="center">
            <van-col span="22">
                <van-button type="primary" size="large" @click="changeSubmit" class="btn">提交</van-button>
            </van-col>
        </van-row>
      <van-row>
        <van-col span="20" offset="2" class="van-cell_red">若有多个共有人输入信息以中文逗号(，)间隔</van-col>
      </van-row>


    </div>
</template>

<script>
    import Top from '@/views/components/Top'
    import { regions, changeApply, fetchBldCellHouses,fetchAuditOwnerInfo} from '@/api/maintainFund/maintainFund'
    import {isMobile} from "vant/lib/utils/validate/mobile";
    import { Uploader,NoticeBar } from 'vant';

    export default {
        name: "ownerChange",
        data() {
            return {
                regionName: '',
                regionSearchName:'',
                regionNo: '',
                onLineDeposit: '',
                region: {},
                regionList: [],
                showPicker: false,
                ownerName: '',
                ownerCertNo: '',
                searchShow: false,
                houseDate:[],
                houseValue: "",
                defaultIndex: [0, 0, 0],
                busiType: '',
                busiTypeName: '',
                typeShow: false,
                ownerName1: '',
                ownerCertNo1: '',
                typeData: [],
                phoneNo: '',
                bdcdyh: '',
                fileList1: [],
                fileShowList1: [],
                fileList2: [],
                fileShowList2: [],
                fileList3: [],
                fileShowList3: [],
                bindNumber: 0,
                changeInfoData: []

            }
        },
         created() {
           this.fileList1 = []
           this.fileList2 = []
           this.fileList3 = []
           this.fileShowList1 = []
           this.fileShowList2 = []
           this.fileShowList3 = []
         },
        mounted() {
            document.addEventListener('click', this.houseListClose);
          fetchAuditOwnerInfo().then(res => {
            this.bindNumber = res.data.length;
            this.changeInfoData = res.data;
          })
        },
        watch: {
            regionName() {
                this.fetchData();
            }
        },
        components: {
            BvTop: Top,
            VanUploader: Uploader,
            VanNoticeBar: NoticeBar
        },
        methods: {
            async  fetchData() {
                this.houseValue = "";
                let param = {
                    regionName: this.regionName
                }
                if (this.regionSearchName != this.regionName){
                    regions(param).then(response => {
                        this.searchShow = false;
                        this.RegionList = response.data;
                        this.searchShow = true;
                    }).catch(() => {
                        this.searchShow = false;
                    });
                }
            },
          goChangeOwnerReview() {
            this.$router.push({path: '/maintainFund/OwnerChangeList', query: {changeInfoData: this.changeInfoData}})
          },
            //小区下拉列表点击
            regionListClick: function (region) {
                this.region = region;
                this.divisionCode = region.divisionCode;
                this.regionName = region.regionName;
                this.regionSearchName = region.regionName;
                this.regionNo = region.regionNo;
                this.searchShow = false;
                this.onLineDeposit = region.onLineDeposit
            },

            //房屋选择器变化函数
            housePickerChange(picker, values, index) {
                let that_ = this;
                if (values[0]) {
                    that_.bld = values[0].key;
                }
                if (values[1]) {
                    that_.cell = values[1].key;
                }
                if (values[2]) {
                    that_.house = values[2].key;
                }
                let param = {
                    regionNo: this.regionNo
                };
                if (index === 0) {
                    that_.loading = true;
                    param.bldNo = that_.bld;
                    fetchBldCellHouses(param).then(response => {
                        const data = response.data;

                        this.$set(this.houseDate, 1, {
                            values: data[0]
                        });
                        this.$set(this.houseDate, 2, {
                            values: data[1]
                        });

                        if (data[0].length > 0 && data[1].length > 0) {
                            this.currentHouse = values[0].text + '-' + data[0][0].text + '-' + data[1][0].text;
                        } else {
                            this.currentHouse = '';
                        }

                        that_.loading = false;
                    })
                }
                if (index === 1) {
                    that_.loading = true;
                    param.bldNo = that_.bld;
                    param.cellNo = that_.cell;
                    fetchBldCellHouses(param).then(response => {
                        const data = response.data;
                        this.$set(this.houseDate, 2, {
                            values: data[0]
                        });
                        if (data[0].length > 0) {
                            this.currentHouse = values[0].text + '-' + values[1].text + '-' + data[0][0].text;
                        } else {
                            this.currentHouse = '';
                        }

                        that_.loading = false
                    })
                }
                if (index === 2) {
                    this.address = values[2].extra;
                    this.currentHouse = values[0].text + '-' + values[1].text + '-' + values[2].text;
                    this.defaultCell = values[1].text;
                    this.defaultHouse = values[2].text;
                }
            },

            //点击空白处关闭列表
            houseListClose: function () {
              this.searchShow = false
            },

            //选择房屋
            houseInputClick() {
                if (this.regionNo) {
                    let param = {
                        regionNo: this.regionNo
                    };
                    fetchBldCellHouses(param).then(response => {
                        const data = response.data;
                        this.$set(this.houseDate, 0, {
                            values: data[0]
                        });
                        this.$set(this.houseDate, 1, {
                            values: data[1]
                        });
                        this.$set(this.houseDate, 2, {
                            values: data[2]
                        });
                        this.showPicker = true
                        this.houseDate.$forceUpdate()
                        if (this.houseValue === '') {
                            //获取后台返回默认值，往选择楼栋页面位置展示
                            this.houseValue = data[0][0].text + '-' + data[1][0].text + '-' + data[2][0].text
                        } else {
                            //获取用户选择获得值，往选择楼栋页面位置展示
                            this.$set(this.houseDate, 1, {
                                values: this.defaultCell
                            });
                            this.$set(this.houseDate, 2, {
                                values: this.defaultHouse
                            });
                        }
                    }).catch(
                        this.houseDate = []
                    )
                } else {
                    this.$dialog.alert({
                        message: '请先选择小区'
                    });
                }
            },



            //选择房屋回显赋值
            onConfirmHouse(values) {

                if (values[0] && values[1] && values[2]) {
                    this.cellNo = values[1].key
                    this.houseNo = values[2].key
                    this.houseValue = values[0].text + '-' + values[1].text + '-' + values[2].text;
                    this.showPicker = false;
                } else {
                    this.$toast.fail("请选择绑定房屋...");
                    return;
                }
            },

            //变更申请
            changeSubmit() {
              let mesInfo = this.isIdCardNo(this.ownerCertNo,'owner')
               if( mesInfo!= 'success') {
                 this.$dialog.alert({
                   message: mesInfo
                 }).catch()
                 return false
               }
             if(this.ownerCertNo1.length>0){
               let  mesInfo1 = this.shareCardNo(this.ownerCertNo1,'share')
               if( mesInfo1 != 'success') {
                 this.$dialog.alert({
                   message: mesInfo1
                 }).catch()
                 return false
               }
             }


              if(!this.isPhoneNo(this.phoneNo)) {
                this.$dialog.alert({
                  message: "请输入正确的手机号"
                }).catch()
                return false
              }

                  if (this.houseNo == null || this.houseNo == null) {
                    this.$dialog.alert({
                      message: "请先正确选择房屋"
                    }).catch()
                  }else  if (this.fileList1.length == 0) {
                    this.$dialog.alert({
                      message: "请上传身份证正面图片"
                    }).catch()
                  }else  if (this.fileList2.length == 0) {
                    this.$dialog.alert({
                      message: "请上传身份证反面图片"
                    }).catch()
                  }else  if (this.fileList3.length == 0) {
                    this.$dialog.alert({
                      message: "请上购买合同或房本图片"
                    }).catch()
                  } else {

                    let formData = new FormData();
                    if (this.fileList1) {
                      this.fileList1.forEach((value) => {
                        formData.append('file1', value);
                      });
                      this.fileList2.forEach((value) => {
                        formData.append('file2', value);
                      });
                      this.fileList3.forEach((value) => {
                        formData.append('file3', value);
                      });
                    }
                    formData.append("regionNo", this.regionNo);
                    formData.append("cellNo", this.cellNo);
                    formData.append("houseNo", this.houseNo);
                    formData.append("ownerName", this.ownerName);
                    formData.append("ownerCertNo", this.ownerCertNo);
                    formData.append("ownerName1", this.ownerName1);
                    formData.append("ownerCertNo1", this.ownerCertNo1);
                    formData.append("phoneNo", this.phoneNo);
                    formData.append("bdcdyh", this.bdcdyh);

                    changeApply(formData).then(res => {
                      if (res.data.retCode === '0000') {
                        this.$dialog.alert({
                          message: res.data.retDesc
                        }).then(() => {
                          this.$router.push({path: '/maintainFund'})
                        });
                      }else{
                        this.$dialog.alert({
                          message: res.data.retDesc
                        }).then(() => {
                          return false;
                        })
                      }
                    })
                  }

            },


          validateMobile(value) {
            return isMobile(value);
          },
          //图片上传后
          afterRead1(file) {
            if (!file.file.type.includes('image/')) {
              this.$dialog.alert({
                message: "请选择正确的图格式"
              }).catch()
              return false
            }
            //存入提交数据
            this.fileList1.push(file.file)
          },
          afterRead2(file) {
            if (!file.file.type.includes('image/')) {
              this.$dialog.alert({
                message: "请选择正确的图格式"
              }).catch()
              return false
            }
            //存入提交数据
            this.fileList2.push(file.file)
          },
          afterRead3(file) {

            //存入提交数据
            this.fileList3.push(file.file)
          },
          //预览删除
          delImg1(file,detail) {
            this.fileShowList1.splice(detail.index, 1)
            this.fileList1.splice(detail.index, 1)
          },
          //预览删除
          delImg2(file,detail) {
            this.fileShowList2.splice(detail.index, 1)
            this.fileList2.splice(detail.index, 1)
          },
          //预览删除
          delImg3(file,detail) {
            this.fileShowList3.splice(detail.index, 1)
            this.fileList3.splice(detail.index, 1)
          },
          //判断文件类型
          beforeRead1(file) {
            if (!file.type.includes('image/')) {
              this.$dialog.alert({
                message: "请选择正确的图格式"
              }).catch()
              return false;
            }else {
              return true;
            }

          },
          isPhoneNo(phoneNumber) {
            if (phoneNumber.length !== 11) {
              return false;
            }
            var reg = /^1\d{10}$/;
            return reg.test(phoneNumber);

          },
          shareCardNo(num,flag){
           if(num.indexOf("，") != -1) {
              let arr = num.split("，")
              let meg = ''
              for(let i = 0; i < arr.length; i++) {
                meg = this.isIdCardNo(arr[i],flag)
                if(meg != 'success') {
                  break
                }

              }
              return meg;

            }else if(num.length == 15 || num.length == 18) {
              return this.isIdCardNo(num,flag)
            }else {
              return '共有人身份证号输入格式不正确'
            }

          },
          isIdCardNo(num,flag) {
            num = num.toUpperCase();
            // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
            if (num.length !== 15 && num.length !== 18) {
              if (flag == 'owner'){
                return '身份证号长度不对';
              }else{
                return '共有人身份证号长度不对';
              }
            }
            if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
              if (flag == 'owner'){
                return '15位号码应全为数字，18位号码末位可以为数字或X。';
              }else{
                return '共有人15位号码应全为数字，18位号码末位可以为数字或X。';
              }
            }
            // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            // 下面分别分析出生日期和校验位
            let len, re;
            len = num.length;
            if (len == 15) {
              re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
              let arrSplit = num.match(re);
              // 检查生日日期是否正确
              let dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/'
                  + arrSplit[4]);
              let bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2]))
                  && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3]))
                  && (dtmBirth.getDate() == Number(arrSplit[4]));
              if (!bGoodDay) {
                if (flag == 'owner'){
                  return '输入的身份证号里出生日期不对！';
                }else{
                  return '输入的共有人身份证号里出生日期不对！';
                }

              } else {
                // 将15位身份证转成18位
                // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
                let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5,
                    8, 4, 2);
                let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4',
                    '3', '2');
                let nTemp = 0, i;
                num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
                for (i = 0; i < 17; i++) {
                  nTemp += num.substr(i, 1) * arrInt[i];
                }
                num += arrCh[nTemp % 11];
///			return num;
              }
            }
            if (len === 18) {
              re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
              let arrSplit = num.match(re);
              // 检查生日日期是否正确
              let dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/"
                  + arrSplit[4]);
              let bGoodDay;
              bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2]))
                  && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3]))
                  && (dtmBirth.getDate() == Number(arrSplit[4]));
              if (!bGoodDay) {
                if (flag == 'owner'){
                  return '输入的身份证号里出生日期不对！';
                }else{
                  return '输入的共有人身份证号里出生日期不对！';
                }
              } else {
                // 检验18位身份证的校验码是否正确。
                // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
                let valnum;
                let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5,
                    8, 4, 2);
                let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4',
                    '3', '2');
                let nTemp = 0, i;
                for (i = 0; i < 17; i++) {
                  nTemp += num.substr(i, 1) * arrInt[i];
                }
                valnum = arrCh[nTemp % 11];
                if (valnum != num.substr(17, 1)) {
                  if (flag == 'owner'){
                    return '输入的身份证号有误！';
                  }else{
                    return '输入的共有人身份证号有误！';
                  }

                }
///			return num;
              }
            }
            return 'success';
          }

        },


    }
</script>

<style lang='scss' scoped>
    .ownerChange {
        height: 100vh;
        background: #f2f2f2;

        .btn {
            margin-top: 5%;
            border-radius: 5px;
            background-color: #2acba2 !important;
            border: 1px solid #2acba2 !important;
        }

        .footFont {
            font-weight: normal;
            font-size: 14px;
            color: #999;
        }
    }

    .regionList {
        z-index: 100;
        position: absolute;
        width: 100%;
        margin-left: 25%;
        display: inline !important;
        list-style: none;
        overflow-y: scroll;
        line-height: 2;
        border-radius: 6px;
        background: white;

    }
    .van-cell_value {
      min-width: 70%;
      display: inline-block;
      text-align: left;
      word-break: break-all;
    }
    .van-cell_red {
      color: #ff0000;
    }

</style>
